import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter , Route } from 'react-router-dom';
import './index';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/antd.css';

// 兼容ie
import 'core-js/es'  
import 'react-app-polyfill/ie9'  
import 'react-app-polyfill/stable'

ReactDOM.render(
	<HashRouter>
    	<Route path="/" render={props=>{
			return <App  {...props} />
		}}  />
  </HashRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
